module.exports = __webpack_public_path__ + "pcstatic/img/logo.2893f82.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image1/logo.png
// module id = R5GR
// module chunks = 34